import { Directive, Injector, Input } from "@angular/core";
import { BfxFieldDirective } from "./bfx-field";

const BFX_FIELD_NUMBER_DIRECTIVE = "bfx-field-number";

@Directive({
  selector: `[${BFX_FIELD_NUMBER_DIRECTIVE}]`,
  host: { class: "bfx-field-number-container" },
  exportAs: "bfxFieldNumber",
  standalone: false,
})
export class BfxFieldNumberDirective extends BfxFieldDirective {
  @Input(BFX_FIELD_NUMBER_DIRECTIVE)
  directiveInput: Record<string, any>;

  directiveInputName = BFX_FIELD_NUMBER_DIRECTIVE;

  constructor(injector: Injector) {
    super(injector);
  }
}
